import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "p-no-float-label" }
const _hoisted_2 = {
  key: 0,
  class: "tags"
}
const _hoisted_3 = { class: "skill-search" }

import { ref, computed } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { createSkillService } from '@/services/skillService';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'TechSkillSelector',
  props: {
    modelValue: {},
    invalid: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

    const { t } = useI18n();

    const props = __props;

    const skill = ref();
    const autocomplete = ref();

    const emit = __emit
    const selectedSkills = computed({
        get: () => props.modelValue,
        set: (value) => {
            emit('update:modelValue', value);
        }
    });

    const skills = ref([]);

    const skillSelected = () => {
        if(!selectedSkills.value)
            selectedSkills.value = []

        if (!selectedSkills.value.find(s => s.id == skill.value.id))
            selectedSkills.value.push(skill.value);
        skill.value = "";
    };

    const skillRemoved = (id) => {
        selectedSkills.value = selectedSkills.value.filter(x=>x.id != id);
    };

    const loadSkillsForAutocomplete = async (event) => {
        const service = await createSkillService();
        let query = "";
        if (event.query)
            query = event.query.trim()
        const data = await service.getTechSkillsByName(query);
        skills.value = data.data.data;
        autocomplete.value.show();
    };

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (selectedSkills.value.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedSkills.value, (skill) => {
            return (_openBlock(), _createElementBlock("li", {
              key: skill.name
            }, [
              _createTextVNode(_toDisplayString(skill.name) + " ", 1),
              _createVNode(_component_Button, {
                icon: "pi pi-times",
                class: "p-button-rounded p-button-outlined",
                onClick: ($event: any) => (skillRemoved(skill.id)),
                "data-cy": "wizard-competences-chosen"
              }, null, 8, ["onClick"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (selectedSkills.value?.length <5)
        ? (_openBlock(), _createBlock(_component_AutoComplete, {
            key: 0,
            modelValue: skill.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((skill).value = $event)),
            id: "skills",
            "data-cy": "wizard-choose-competences",
            suggestions: skills.value,
            onComplete: _cache[1] || (_cache[1] = ($event: any) => (loadSkillsForAutocomplete($event))),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (loadSkillsForAutocomplete($event))),
            onItemSelect: skillSelected,
            field: "name",
            class: _normalizeClass({ 'p-invalid': _ctx.invalid }),
            style: {"height":"60px","color":"#ced4da !important"},
            placeholder: _unref(t)('signup.tech.skills.label'),
            minLength: 0,
            ref_key: "autocomplete",
            ref: autocomplete
          }, null, 8, ["modelValue", "suggestions", "class", "placeholder"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})